import useDebounce from '@UI/Hooks/useDebounce';
import subjectFiltersSignal, {
	setSubjectFilters,
} from '@UI/Pages/Subjects/SubjectList/Filters/Signals/subjectFiltersSignal';
import * as React from 'react';
import { useSignalValue } from '@verclam/pulsar';
import { InputText } from '@verclam/ui-kit';
import { fieldWithoutMarginStyles } from '@Guidelines/Theme/commonPassthrough';

const SEARCH_DEBOUNCE_DELAY_IN_MILLISECONDS = 300;

/**
 * Keeps local state for immediate keystroke feedback while the write to `subjectFiltersSignal` is
 * debounced. The local state is resynchronised from the signal whenever it changes for another reason
 * (a reset, a change of type), so the field never shows stale text.
 */
const SearchFilter: React.FC = () => {
	const currentFilters = useSignalValue(subjectFiltersSignal);
	const [searchInput, setSearchInput] = React.useState(currentFilters.search);
	const debouncedSearch = useDebounce(searchInput, SEARCH_DEBOUNCE_DELAY_IN_MILLISECONDS);

	React.useEffect(() => {
		setSearchInput(currentFilters.search);
	}, [currentFilters.search]);

	React.useEffect(() => {
		if (debouncedSearch === subjectFiltersSignal.peek().search) {
			return;
		}

		setSubjectFilters(subjectFiltersSignal.peek().setSearch(debouncedSearch));
	}, [debouncedSearch]);

	const handleSearchChange = React.useCallback((value: string) => {
		setSearchInput(value);
	}, []);

	return (
		<InputText
			name="subjectSearch"
			label="Recherche"
			isLabelHidden
			placeholder="Rechercher un intitulé…"
			value={searchInput}
			onChange={handleSearchChange}
			pt={fieldWithoutMarginStyles}
		/>
	);
};

export default SearchFilter;
